/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import {
  Analytics as TrackersIcon,
  BarChart as ReportsIcon,
  ChangeHistory as ChangelistIcon,
  CloudQueue as CloudIcon,
  DynamicFeed as GroupsIcon,
  FormatListBulleted as JobsIcon,
  Input as LogoutIcon,
  FourKPlus as IpcountIcon,
  Pageview as PageviewIcon,
  PhoneAndroid as DeviceIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

import { t } from 'i18n';

const cfg = [
  {
    title: t('Job Groups'),
    href: '/groups',
    icon: GroupsIcon,
  },
  {
    title: t('Job List'),
    href: '/jobs',
    icon: JobsIcon,
  },
  {
    title: t('Daily Report'),
    href: '/reports/jobdaily',
    icon: ReportsIcon,
  },
  {
    title: t('Trackers Report'),
    href: '/reports/trackers',
    icon: TrackersIcon,
  },
  {
    title: t('Device Usage'),
    href: '/jobs/devusage',
    icon: DeviceIcon,
  },
  {
    title: t('IPUA UV Count'),
    href: '/jobs/ipuauv',
    icon: PageviewIcon,
  },
  {
    title: t('Jobs Changelist'),
    href: '/jobs/changelist',
    icon: ChangelistIcon,
  },
  {
    title: 'Extra Reports',
    href: '/reports/extra/',
    icon: ReportsIcon,
    needAdmin: true,
    children: [{
      title: 'Total Org Cost',
      href: '/reports/extra/total-org-cost',
      icon: ReportsIcon,
    }, {
      title: 'Monthly Cost',
      href: '/reports/extra/monthly-cost',
      icon: ReportsIcon,
    }, {
      title: 'Monthly Cost Details',
      href: '/reports/extra/monthly-cost-details',
      icon: ReportsIcon,
    }, {
      title: 'Monthly Plan',
      href: '/reports/extra/monthly-plan',
      icon: ReportsIcon,
    }, {
      title: 'Monthly Plan Details',
      href: '/reports/extra/monthly-plan-details',
      icon: ReportsIcon,
    }],
  },
  {
    title: t('IP Count'),
    href: '/ipcount',
    icon: IpcountIcon,
  },
  {
    title: t('Cloudboard'),
    href: '/cloudboard',
    icon: CloudIcon,
    needAdmin: true,
  },
  {
    title: t('Settings'),
    href: '/settings',
    icon: SettingsIcon,
  },
  {
    title: t('Logout'),
    href: '/auth/logout',
    icon: LogoutIcon,
  },
];

export default cfg;
